import { ASSET_STATUS, LOANER_STATUS } from '../../../config';

const CONTEXT_MENU_ITEMS = {
  VIEW_SERVICE_REQUEST_FOR_LOANER_DEVICE:
    'View Service Request For Loaner Device',
  VIEW_SERVICE_REQUEST_FOR_PATIENT_DEVICE:
    'View Service Request For Patient Device',
  REPORT_ISSUE: 'Report Issue',
  ASSIGN_LOANER: 'Assign Loaner',
  RETURN_LOANER: 'Return Loaner',
};

const getToolbarConfig = ({
  labels,
  filterLoaners,
  resetFilters,
  providerRegion,
  filterCounts = {},
  isBackgroundFetching = false,
}) => {
  return {
    resetDeviceFilters: resetFilters,
    defaultSelection: 'apps',
    items: [
      {
        type: 'breadcrumb',
        align: 'left',
        icon: '',
        sections: [
          {
            text: labels['labels.clinicEquipment.toolBar.items.show'],
            action: () => {},
          },
        ],
      },
      {
        type: 'filter-button',
        align: 'left',
        icon: 'apps',
        text: labels['labels.clinicEquipment.toolBar.items.all'],
        onHandle: resetFilters,
        analytics: 'filter_all_clinic_equipments',
        isLoading: isBackgroundFetching,
      },
      {
        type: 'text-filter-button',
        align: 'left',
        icon: 'exchangeStock',
        text: labels[
          `labels.clinicEquipment.toolBar.items.exchangeStock`
        ],
        onHandle: () => filterLoaners('exchangeStock'),
        analytics: 'filter_exchange_stock',
        disabled: filterCounts.exchangeStock === 0,
        isLoading: isBackgroundFetching,
      },
      {
        type: 'text-filter-button',
        align: 'left',
        icon: 'loanerWithClinic',
        text: labels[
          `labels.clinicEquipment.toolBar.items.loanerWithClinic`
        ],
        onHandle: () => filterLoaners('loanerWithClinic'),
        analytics: 'filter_loaner_with_clinic',
        disabled: filterCounts.loanerWithClinic === 0,
        isLoading: isBackgroundFetching,
      },
      {
        type: 'text-filter-button',
        align: 'left',
        icon: 'loanerInUse',
        text: labels[
          `labels.clinicEquipment.toolBar.items.loanerInUse`
        ],
        onHandle: () => filterLoaners('loanerInUse'),
        analytics: 'filter_loaner_in_use',
        disabled: filterCounts.loanerInUse === 0,
        isLoading: isBackgroundFetching,
      },
      ...(providerRegion === 'APAC'
        ? [
            {
              type: 'text-filter-button',
              align: 'left',
              icon: 'loanerInUseNoSr',
              text: labels[
                `labels.clinicEquipment.toolBar.items.loanerInUseNoSr`
              ],
              onHandle: () => filterLoaners('loanerInUseWithoutSR'),
              analytics: 'filter_loaner_in_use_without_sr',
              disabled: filterCounts.loanerInUseWithoutSR === 0,
              isLoading: isBackgroundFetching,
            },
          ]
        : []),
      {
        type: 'text-filter-button',
        align: 'left',
        icon: 'loanerReturnRecommended',
        text: labels[
          `labels.clinicEquipment.toolBar.items.loanerReturnRecommended`
        ],
        onHandle: () => filterLoaners('loanerReturnRecommended'),
        analytics: 'filter_loaner_return_recommended',
        disabled: filterCounts.loanerReturnRecommended === 0,
        isLoading: isBackgroundFetching,
      },
      {
        type: 'text-filter-button',
        align: 'left',
        icon: 'loanerReturnCritical',
        text: labels[
          `labels.clinicEquipment.toolBar.items.loanerReturnCritical`
        ],
        onHandle: () => filterLoaners('loanerReturnCritical'),
        analytics: 'filter_loaner_return_critical',
        disabled: filterCounts.loanerReturnCritical === 0,
        isLoading: isBackgroundFetching,
      },
    ],
  };
};

const getDevicesTableConfig = ({
  data,
  fetchExpandedData,
  labels,
  handleReportIssue,
  handleViewServiceRequest,
  handleAssignLoaner,
  handleReturnLoaner,
  providerRegion,
}) => {
  return {
    columns: [
      // dummy column for rendering preloader (in CDS) correctly
      {
        format: {
          expanded: {
            type: 'emptycell',
          },
        },
      },
      {
        display:
          'labels.clinicEquipment.dataTable.columns.header.blank',
        format: {
          collapsed: {
            type: 'icontoggle',
          },
          expanded: {
            type: 'composite',
            template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 -8px; width:200%'></div>`,
          },
        },
        sortable: false,
      },
      {
        display:
          'labels.clinicEquipment.dataTable.columns.header.device',
        format: {
          collapsed: {
            type: 'composite',
            template: `<div>
                <div style="width: 1.5rem">
                </div>
                <div>
                  <span class="ccl__text ccl__text--body-text-bold ">{{productType}}</span>
                </div>
              </div>`,
          },
          expanded: {
            type: 'composite',
            template: `
              <div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:110%; padding: 8px 25px 5px 0'>{{#expandedDataL}}{{#value}}<div style='padding:7px 12px 0 0;'><p class='ccl__text ccl__text--x-small-body-text-bold' style='display:inline'>{{label}}: </p> <p class='ccl__text ccl__text--x-small-body-text' style='display:inline'>{{value}}</p></div>{{/value}}{{/expandedDataL}}</div>
          `,
          },
        },
        hiddenColumnView: 'mobile',
        sortable: false,
      },
      {
        display:
          'labels.clinicEquipment.dataTable.columns.header.model',
        field: 'model',
        format: {
          collapsed: {
            template: `<div><span class="ccl__text ccl__text--interactive-text">{{productDescription}}</span></div><div>{{formattedSerialNumber}}</div>`,
            type: 'composite',
          },
          expanded: {
            type: 'composite',
            template: `
              <div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:105%; padding: 8px 25px 5px 0'>{{#expandedDataR}}{{#value}}<div style='padding:7px 12px 0 0;'><p class='ccl__text ccl__text--x-small-body-text-bold' style='display:inline'>{{label}}: </p> <p class='ccl__text ccl__text--x-small-body-text' style='display:inline'>{{value}}</p></div>{{/value}}{{/expandedDataR}}</div>
            `,
          },
        },
        hiddenColumnView: 'mobile',
        sortable: false,
      },
      {
        display:
          'labels.clinicEquipment.dataTable.columns.header.type',
        field: 'status',
        format: {
          collapsed: {
            type: 'composite',
            template: `<div>
                <div style="width: 1.5rem">
                </div>
                <div>
                  <span class="ccl__text ccl__text--body-text-bold ">{{formattedStatus}}</span>
                </div>
              </div>`,
          },
          expanded: {
            type: 'emptycell',
          },
        },
        hiddenColumnView: 'mobile',
        sortable: false,
      },
      {
        display: 'labels.dataTable.examples.columnHeaders.blank',
        field: 'view',
        format: {
          collapsed: {
            type: 'contextMenu',
            variant: 'tinted',
            items: [
              {
                name: CONTEXT_MENU_ITEMS.VIEW_SERVICE_REQUEST_FOR_LOANER_DEVICE,
                text: labels[
                  'labels.clinicEquipment.dataTable.actions.viewServiceRequestForThisDevice'
                ],
                onclick: (row) => handleViewServiceRequest(row),
              },
              {
                name: CONTEXT_MENU_ITEMS.VIEW_SERVICE_REQUEST_FOR_PATIENT_DEVICE,
                text: labels[
                  'labels.clinicEquipment.dataTable.actions.viewServiceRequestForRecipientDevice'
                ],
                onclick: (row) => handleViewServiceRequest(row),
              },
              {
                name: CONTEXT_MENU_ITEMS.REPORT_ISSUE,
                text: labels[
                  'labels.clinicEquipment.dataTable.actions.reportIssue'
                ],
                onclick: (row) => handleReportIssue(row),
              },
              {
                name: CONTEXT_MENU_ITEMS.ASSIGN_LOANER,
                text: labels[
                  'labels.clinicEquipment.dataTable.actions.assignLoaner'
                ],
                onclick: (row) => handleAssignLoaner(row),
              },
              {
                name: CONTEXT_MENU_ITEMS.RETURN_LOANER,
                text: labels[
                  'labels.clinicEquipment.dataTable.actions.returnLoanerDevice'
                ],
                onclick: (row) => handleReturnLoaner(row),
              },
            ],
            map: data?.map((row) => {
              const contextMenuOptions = [];

              if (row.status === ASSET_STATUS.ExchangeStock) {
                contextMenuOptions.push(
                  CONTEXT_MENU_ITEMS.REPORT_ISSUE,
                );
              } else {
                switch (row.loanerStatus) {
                  case LOANER_STATUS.LoanerWithClinic:
                    if (!row.serviceRequest?.id) {
                      contextMenuOptions.push(
                        CONTEXT_MENU_ITEMS.REPORT_ISSUE,
                      );
                      // Only add Assign Loaner for APAC region
                      if (providerRegion === 'APAC') {
                        contextMenuOptions.push(
                          CONTEXT_MENU_ITEMS.ASSIGN_LOANER,
                        );
                      }
                    }
                    break;

                  case LOANER_STATUS.LoanerInUse:
                    contextMenuOptions.push(
                      CONTEXT_MENU_ITEMS.VIEW_SERVICE_REQUEST_FOR_PATIENT_DEVICE,
                    );
                    break;
                  case LOANER_STATUS.LoanerInUseWithoutSR:
                    contextMenuOptions.push(
                      CONTEXT_MENU_ITEMS.RETURN_LOANER,
                    );
                    break;
                  case LOANER_STATUS.LoanerReturnRecommended:
                  case LOANER_STATUS.LoanerReturnCritical:
                    contextMenuOptions.push(
                      CONTEXT_MENU_ITEMS.RETURN_LOANER,
                    );
                    break;

                  default:
                    break;
                }
              }

              // Only return the menu item if there are options
              if (contextMenuOptions.length > 0) {
                return {
                  id: row.id,
                  items: contextMenuOptions,
                };
              }
              return {};
            }),
          },
          expanded: {
            type: 'composite',
            template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px -20% 0 0;'></div>`,
          },
        },
        hiddenColumnLabel: true,
        restrictWidth: true,
        sortable: false,
      },
    ],
    country: 'US',
    language: 'en',
    formats: {
      date: 'mmm dd yyyy',
      currency: 'USD',
    },
    labels: {
      rowLoading: 'labels.clinicEquipment.dataTable.view.loading',
    },
    handleExpand: fetchExpandedData,
    handleSortDataChange: function noRefCheck() {},
    mode: '',
    loadingText: 'labels.clinicEquipment.dataTable.view.loading',
    hasCollapseContent: true,
    highlight: false,
    hover: true,
    hiddenColumnLabel: true,
    restrictWidth: true,
    sortable: false,
    resultsLimit: {
      // maxResults: 100,
      content:
        'labels.clinicEquipment.dataTable.resultsLimit.content',
      additional: {
        textOrder:
          'labels.clinicEquipment.dataTable.resultsLimit.additional.textOrder',
        text1:
          'labels.clinicEquipment.dataTable.resultsLimit.additional.text1',
        text2:
          'labels.clinicEquipment.dataTable.resultsLimit.additional.text2',
        linkText1:
          'labels.clinicEquipment.dataTable.resultsLimit.additional.linkText1',
        function1: () => {},
      },
    },
    noSearchResults: {
      additional: {
        function1: () => {},
        function2: () => {},
        linkText1:
          'labels.clinicEquipment.dataTable.noSearchResults.additional.linkText1',
        linkText2:
          'labels.clinicEquipment.dataTable.noSearchResults.additional.linkText2',
        text1:
          'labels.clinicEquipment.dataTable.noSearchResults.additional.text1',
        text2:
          'labels.clinicEquipment.dataTable.noSearchResults.additional.text2',
        textOrder:
          'labels.clinicEquipment.dataTable.noSearchResults.additional.textOrder',
      },
      content:
        'labels.clinicEquipment.dataTable.noSearchResults.content',
      format:
        'labels.clinicEquipment.dataTable.noSearchResults.format',
      isClinicPopup: true,
      pictogramName: '404Error2',
      pictogramSrc:
        'https://mss-p-007-delivery.stylelabs.cloud/api/public/content/66c25eb795cd471a8e7e1dc06c32408a?v=1ccadacd',
    },
  };
};

export { getToolbarConfig, getDevicesTableConfig };
